"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var qmRouter = {
  path: '/qm',
  component: _layout.default,
  redirect: '/qm',
  name: '青民',
  alwaysShow: true,
  meta: {
    title: '青民车辆核销',
    icon: 'clipboard'
  },
  children: [{
    path: '/car/order/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/qm/order/index'));
      });
    },
    name: 'QmOrderIndex',
    meta: {
      title: '青民车辆核销订单管理'
    }
  }, {
    path: '/car/test/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/qm/test/index'));
      });
    },
    name: 'QmTestIndex',
    meta: {
      title: '青民车辆安全检测管理'
    }
  }, {
    path: '/car/reservation/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/qm/reservation/index'));
      });
    },
    name: 'QmReservationOrderIndex',
    meta: {
      title: '青民车辆预定订单管理'
    }
  }]
};
var _default = exports.default = qmRouter;